"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SynthRegistryV2Factory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var SynthRegistryV2Factory = /** @class */ (function (_super) {
    __extends(SynthRegistryV2Factory, _super);
    function SynthRegistryV2Factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    SynthRegistryV2Factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    SynthRegistryV2Factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    SynthRegistryV2Factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    SynthRegistryV2Factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    SynthRegistryV2Factory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return SynthRegistryV2Factory;
}(contracts_1.ContractFactory));
exports.SynthRegistryV2Factory = SynthRegistryV2Factory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "proxy",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "synth",
                type: "address",
            },
        ],
        name: "SynthAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "proxy",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "synth",
                type: "address",
            },
        ],
        name: "SynthRemoved",
        type: "event",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "core",
                type: "address",
            },
            {
                internalType: "address",
                name: "synthetic",
                type: "address",
            },
        ],
        name: "addSynth",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "availableCores",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getAllCores",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "core",
                type: "address",
            },
        ],
        name: "removeSynth",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "synths",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
//# sourceMappingURL=SynthRegistryV2Factory.js.map